import { render, staticRenderFns } from "./TournamentTable.vue?vue&type=template&id=beee1304&scoped=true"
import script from "./TournamentTable.vue?vue&type=script&lang=js"
export * from "./TournamentTable.vue?vue&type=script&lang=js"
import style0 from "./TournamentTable.vue?vue&type=style&index=0&id=beee1304&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "beee1304",
  null
  
)

export default component.exports